<script setup lang="ts">
import {Cat, Check, Dog} from '@lucide/vue';
import {Pet} from "@/customer/interfaces/Pet";

defineProps<{
    pets: Pet[];
    /** The pets already answered for, marked as done in the list. */
    qualifiedPetIds?: number[];
}>();

const selected = defineModel<Pet | null>({required: true});
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-semibold">De quel animal parlons-nous ?</span>
    <div class="flex flex-row flex-wrap gap-3">
      <button
        v-for="pet in pets"
        :key="pet.id"
        type="button"
        class="flex items-center gap-2 rounded-md border px-3 py-1 text-sm shadow-sm"
        :class="selected?.id === pet.id
          ? 'border-primary bg-primary text-white'
          : 'border-gray-300 bg-white text-gray-700 hover:border-primary'"
        @click="selected = pet"
      >
        <Cat v-if="pet.category?.slug === 'cat'" :size="16" />
        <Dog v-else :size="16" />
        {{ pet.name || pet.category?.name }}
        <Check v-if="qualifiedPetIds?.includes(pet.id)" :size="14" />
      </button>
    </div>
  </div>
</template>
